import { AppEnv, displaySmUpSx, displayXsSx } from '@efacity/common';
import { Box, Typography } from '@mui/material';
import { OrganizationNameWithTooltip } from './OrganizationNameWithTooltip';

interface HeaderOrgNameProps {
  isUserLoggedIn: boolean;
  orgName?: string;
  appEnv: AppEnv;
}
export const HeaderOrgName = ({ isUserLoggedIn, orgName, appEnv }: HeaderOrgNameProps) => {
  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexGrow: 1,
        marginLeft: '5px',
        marginRight: '5px',
        fontSize: { xs: 14, sm: 16, md: 20 },
        '& > div': {
          justifyContent: 'center'
        }
      }}
    >
      <Box sx={isUserLoggedIn ? {} : displaySmUpSx}>
        <OrganizationNameWithTooltip organizationName={orgName || ''} appEnv={appEnv} />
      </Box>
      {appEnv !== AppEnv.PROD && !isUserLoggedIn && (
        <Typography sx={{ ...displayXsSx, fontSize: '20px' }} color="error">
          TEST
        </Typography>
      )}
    </Box>
  );
};
